import React from 'react';

const COPYRIGHT = `© ${new Date().getFullYear()} H. H. Hawkins Ltd.`;

interface ActivationCardProps {
  children: React.ReactNode;
}

export const ActivationCard: React.FC<ActivationCardProps> = ({ children }) => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow-lg border-0">
            <div className="card-body p-5">
              {children}
              <div className="text-center mt-4 pt-4 border-top">
                <p className="text-muted small mb-0">{COPYRIGHT}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
